// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:48
import { DataMessage_abstract } from './../../abstract/SagaBase/Defines/DataMessage_abstract';
export class DataMessage extends DataMessage_abstract {}
